import {
  isJyotishaTopicPageKey,
  isNumerologyTopicPageKey,
  topicIdFromPageKey,
  numerologyTopicIdFromPageKey,
  buildAppPageContext,
} from './pageFeedbackKeys';
import { formatJyotishaTopicToastTitle } from '../data/jyotishaTopicLabels';
import { formatNumerologyTopicToastTitle } from 'schools/numerology/data/numerologySearchIndex';

const ANONYMOUS_HI = 'किसी साधक';
const ANONYMOUS_EN = 'Someone';

/**
 * @param {string} pageKey
 * @param {boolean} showEnglish
 */
export function pageTitleFromPageKey(pageKey, showEnglish = false) {
  if (isJyotishaTopicPageKey(pageKey)) {
    const topicId = topicIdFromPageKey(pageKey);
    if (topicId) {
      return formatJyotishaTopicToastTitle(topicId, showEnglish);
    }
  }

  if (isNumerologyTopicPageKey(pageKey)) {
    const topicId = numerologyTopicIdFromPageKey(pageKey);
    if (topicId) {
      return formatNumerologyTopicToastTitle(topicId, showEnglish);
    }
  }

  if (pageKey.startsWith('page:')) {
    const pageId = pageKey.slice('page:'.length);
    const ctx = buildAppPageContext(pageId);
    return showEnglish ? ctx.titleEn ?? ctx.title : ctx.title;
  }

  return pageKey;
}

/**
 * @param {{
 *   pageTitle?: string | null;
 *   pageKey: string;
 *   showEnglish?: boolean;
 * }} input
 */
export function formatPageClapToastMessage(input) {
  const { pageTitle, pageKey, showEnglish = false } = input;
  const title = pageTitleFromPageKey(pageKey, showEnglish) || pageTitle?.trim() || pageKey;
  const name = showEnglish ? ANONYMOUS_EN : ANONYMOUS_HI;

  if (showEnglish) {
    return `${name} just clapped for "${title}"`;
  }

  return `${name} ने अभी "${title}" की प्रशंसा की`;
}
